import { motion } from "framer-motion";

const stats = [
  { value: ">93%", label: "CaO Purity · Quick Lime" },
  { value: "5", label: "Precision Products" },
  { value: "25+", label: "Industries Served" },
  { value: "1", label: "Proprietor · 1 Promise" },
];

const Stats = () => {
  return (
    <section className="bg-[#faf9f6] py-16 lg:py-20 px-5 lg:px-10 border-y border-[#0A2A1E]/15">
      <div className="max-w-[1400px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-10">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.7, delay: i * 0.08 }}
            className="flex flex-col"
          >
            <div className="font-display text-5xl md:text-6xl lg:text-7xl leading-none text-[#0A2A1E]">
              {s.value}
            </div>
            <div className="overline text-[#1E3B30] mt-4">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
